
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 6.781l.313.094L31.657 12l-2.844.938-2.813.938v5.125c0 .82-.499 1.5-1.094 1.969s-1.332.798-2.219 1.094c-1.773.591-4.112.938-6.688.938s-4.914-.346-6.688-.938c-.887-.296-1.624-.625-2.219-1.094s-1.094-1.149-1.094-1.969v-5.125l-2-.656v8.063c.597.346 1 .979 1 1.719a2 2 0 11-4 0c0-.74.403-1.373 1-1.719v-8.75l-1.656-.531 2.844-.938 12.5-4.188zm0 2.094L6.625 12 16 15.125 25.375 12zm-8 5.688v4.438c0 .009-.004.126.313.375s.883.565 1.625.813c1.484.495 3.667.813 6.063.813s4.579-.318 6.063-.813c.742-.247 1.309-.563 1.625-.813s.313-.366.313-.375v-4.438l-7.688 2.563-.313.094-.313-.094z"}})])
          )
        }
      }
    